import { render, staticRenderFns } from "./WELLSDVT.vue?vue&type=template&id=0d201711&scoped=true&"
import script from "./WELLSDVT.vue?vue&type=script&lang=js&"
export * from "./WELLSDVT.vue?vue&type=script&lang=js&"
import style0 from "./WELLSDVT.vue?vue&type=style&index=0&id=0d201711&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d201711",
  null
  
)

export default component.exports